<template>
	<el-dialog :visible.sync="parentVisible" title="取消原因" width="600px">
		<el-form :model="form" ref="form">
      <el-form-item>
        <el-radio-group v-model="form.cancelFactor" @change="onCancelFactorChange" :rules="rules">
          <el-radio :label="1">客户因素</el-radio>
          <el-radio :label="2">审核因素</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="取消原因：" :rules="rules">
        <el-select v-model="form.cancelReason" style="width: 240px">
          <el-option
              v-for="(item, index) in cancelReasonList"
              :key="index"
              :label="item.enumText"
              :value="item.enumCode"
          />
        </el-select>
      </el-form-item>
			<el-form-item label="操作人：">
        <span>{{ loginUerName }}</span>
			</el-form-item>
      <el-form-item label="备注：" :rules="rules">
        <el-input v-model="form.cancelRemark" type="textarea" :rows="4" :maxlength="50"></el-input>
      </el-form-item>
		</el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onCancel">取 消</el-button>
      <el-button type="primary" :loading="confirmLoading" @click="onConfirm">确 定</el-button>
    </div>
	</el-dialog>
</template>

<script>
import {mapState} from "vuex";
import {getCancelReasonAPI, handleOrderCancelAPI} from './api';

export default {
	props: {
		orderNo: {
			type: String,
			default: "",
		},
    visible: {
			type: Boolean,
			defaultValue: false,
		},
	},

	data() {
		return {
      confirmLoading: false,
			form: {
        cancelFactor: 1,
        cancelReason: "",
        cancelRemark: "",
			},
      cancelReasonList: [],
      rules: [{ required: true, message: "该项不能为空", trigger: "blur" }],
		};
	},

  created() {
    this.getCancelReasonList(this.form.cancelFactor);
  },

  computed: {
    ...mapState({ loginUerName: state => state.user.name }),

    parentVisible: {
      get() {
        return this.visible;
      },

      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },

  watch: {
    visible(newValue) {
      if (!newValue) {
        this.resetForm();
      }
    }
  },

  methods: {
    resetForm() {
      this.form.cancelFactor = 1;
      this.form.cancelReason = null;
      this.form.cancelRemark = "";
    },

    getCancelReasonList(cancelFactor) {
      getCancelReasonAPI({cancelFactor}).then(res => {
        this.cancelReasonList = res;
      });
    },

    onCancelFactorChange(value) {
      this.getCancelReasonList(value);
    },

    onCancel() {
      this.$emit("update:visible", false);
    },

    async onConfirm() {
      const param = {
        orderNo: this.orderNo,
        ...this.form,
      };
      const valid = await this.$refs.form.validate();
      if (!valid) {
        return;
      }
      this.confirmLoading = true;
      try {
        await handleOrderCancelAPI(param);
        this.$message({
          type: "success",
          message: "操作成功!",
        });
        this.$emit("refresh");
        this.$emit("update:visible", false);
      } catch (error) {
        console.error(error);
      } finally {
        this.confirmLoading = false;
      }
    }
  }
};
</script>

<style></style>
